import * as React from 'react';
import * as ReactDOM from 'react-dom';
import App from './App';
import './index.css';

function start() {
    ReactDOM.render(
        <App />,
        document.getElementById('root') as HTMLElement
    );
}

try {
    if (location.protocol === "https:" && window.navigator && navigator.serviceWorker) {
        //Initiate our "forgive us for infecting you with this service worker disease" routine
        navigator.serviceWorker.getRegistrations()
            .then(function (registrations) {
                for (let registration of registrations) {
                    registration.unregister();
                }
                start();
            }).catch(err => {
                start(); //Still start anyways
            });
    } else {
        start();
    }
} catch (e) {
    start();
}


// WEBPACK FOOTER //
// ./src/index.tsx